<header class="questionnaire">
    <ol>
      <li class="selected"><span>1</span></li>
      <li class="spacer selected"></li>
      <li class="selected"><div  >Pytanie</div><span>2</span></li>
      <li class="spacer"></li>
      <li><span>3</span></li>
    </ol>
</header>
<main class="questionnaire">
  <h2  ><em>2.</em> Gdzie usytuowany jest budynek?</h2>
  <p>Wybierz jedną dominującą cechę otoczenia.</p>
  <ul>
    <li (click)="onQuestion2Click(Otoczenie.miasto)" [class.selected]="project.ankieta.pytanie2==Otoczenie.miasto"><span  >W mieście, w pobliżu ruchliwej drogi lub zakładów produkcyjnych</span></li>
    <li (click)="onQuestion2Click(Otoczenie.zbiornikWodny)" [class.selected]="project.ankieta.pytanie2==Otoczenie.zbiornikWodny"><span  >W okolicy dużego zbiornika wodnego np. jeziora</span></li>
  </ul><br>
  <ul>
    <li (click)="onQuestion2Click(Otoczenie.las)" [class.selected]="project.ankieta.pytanie2==Otoczenie.las"><span  >Niedaleko parku lub lasu</span></li>
    <li (click)="onQuestion2Click(Otoczenie.brakSzegolow)" [class.selected]="project.ankieta.pytanie2==Otoczenie.brakSzegolow"><span  >Brak szczególnych uwarunkowań otoczenia</span></li>
  </ul>
</main>
<app-footer [prev]="prev" [next]="next"></app-footer>
